import { render, staticRenderFns } from "./SmallIconButton.vue?vue&type=template&id=78a0da18&scoped=true&"
import script from "./SmallIconButton.vue?vue&type=script&lang=js&"
export * from "./SmallIconButton.vue?vue&type=script&lang=js&"
import style0 from "./SmallIconButton.vue?vue&type=style&index=0&id=78a0da18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a0da18",
  null
  
)

export default component.exports